// extracted by mini-css-extract-plugin
export default {"assetButton":"NapCarPassLogo-assetButton","root":"NapCarPassLogo-root","logoNap":"NapCarPassLogo-logoNap","logoCarPass":"NapCarPassLogo-logoCarPass"};